import { render, staticRenderFns } from "./PageLayoutSeven.vue?vue&type=template&id=50b8c49c&scoped=true&"
import script from "./PageLayoutSeven.vue?vue&type=script&lang=js&"
export * from "./PageLayoutSeven.vue?vue&type=script&lang=js&"
import style0 from "./PageLayoutSeven.vue?vue&type=style&index=0&id=50b8c49c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b8c49c",
  null
  
)

export default component.exports